@use "src/sedestral/sass/extends/editor";
@use "src/sedestral/sass/mixins/texts";

.componentWebsiteBlackGuideDetails {
  width: 100%;
  color: var(--black);
  position: sticky;
  top: 35px;

  &.loading {
    height: 100%;
  }

  .loader {
    height: 100%;
    width: 100%;
    position: absolute;
  }

  .score {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 25px;

    .progress {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -5px;

      .semi {
        height: 42px;
        width: 70px;
        overflow: hidden;
      }
    }

    .title {
      font-size: 15px;

      @include texts.font("semi-bold");
    }

    .description {
      font-size: 13px;
      color: var(--grey-text-dark);
    }
  }

  .plan {
    border: 1px solid var(--grey-sur);
    padding: 18px;
    border-radius: 14px;

    .subTitle {
      color: var(--grey-text-dark);
      font-size: 14px;
      margin-bottom: 20px;
    }

    .entries {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .entry {
        display: flex;
        gap: 8px;
        position: relative;
        font-size: 14px;
        cursor: pointer;
        color: var(--black);

        &[data-visible], &:hover {
          color: var(--web-blue);

          .dot {
            width: 14px;
            flex: 0 0 14px;
            background: var(--web-blue);
          }
        }

        .dot {
          height: 2px;
          width: 6px;
          background: var(--black);
          border-radius: 2px;
          margin-top: 8px;
          flex: 0 0 6px;
          transition: 0.25s;
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .plan {
      display: none;
    }
  }
}